import React, { useState } from 'react';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <nav className="bg-white border-b border-slate-200 sticky top-0 z-50 shadow-sm" data-id="element-156">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-157">
        <div className="flex items-center justify-between h-16" data-id="element-158">
          {/* Logo */}
          <div className="flex items-center" data-id="element-159">
            <div className="flex-shrink-0" data-id="element-160">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xA4VGCog93ZhVvQk6fCtDZ/logo-web.png" alt="ArrendaLogic - Soluciones de Arrendamiento" className="h-10 w-auto" data-id="element-161" />
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8" data-id="element-162">
            <a href="#soluciones" className="text-slate-700 hover:text-primary font-medium transition-colors" data-id="element-163">
              Soluciones
            </a>
            <a href="#calculadora" className="text-slate-700 hover:text-primary font-medium transition-colors" data-id="element-164">
              Calculadora
            </a>
            <a href="#como-funciona" className="text-slate-700 hover:text-primary font-medium transition-colors" data-id="element-165">
              ¿Cómo funciona?
            </a>
            <a href="#requisitos" className="text-slate-700 hover:text-primary font-medium transition-colors" data-id="element-166">
              Requisitos
            </a>
            <Button size="sm" data-id="element-167">Cotiza Ahora</Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-168">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-slate-700 hover:text-primary p-2" data-id="element-169">
              {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-170" /> : <MenuIcon className="w-6 h-6" data-id="element-171" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && <div className="md:hidden border-t border-slate-200 bg-white" data-id="element-172">
          <div className="px-4 py-4 space-y-3" data-id="element-173">
            <a href="#soluciones" className="block text-slate-700 hover:text-primary font-medium py-2" data-id="element-174">
              Soluciones
            </a>
            <a href="#calculadora" className="block text-slate-700 hover:text-primary font-medium py-2" data-id="element-175">
              Calculadora
            </a>
            <a href="#como-funciona" className="block text-slate-700 hover:text-primary font-medium py-2" data-id="element-176">
              ¿Cómo funciona?
            </a>
            <a href="#requisitos" className="block text-slate-700 hover:text-primary font-medium py-2" data-id="element-177">
              Requisitos
            </a>
            <Button className="w-full" data-id="element-178">Cotiza Ahora</Button>
          </div>
        </div>}
    </nav>;
}